// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_AT_RULE_IMPORT_0___ = require("-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[6].rules[0].oneOf[1].use[0]!../../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[6].rules[0].oneOf[1].use[1]!../../../assets/theme/css/dashboard.css");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (min-width: 1200px) {
  .teamPerformance {
    width: 100%;
  }
  .performance .card-body .form-group .custom-select {
    font-size: 14px;
    padding: 0;
    width: 85px;
    margin: 4px 7px;
  }
}
.row {
  display: flex;
  flex-wrap: wrap;
}

.table-responsive thead th {
  background: #2a62ff !important;
  color: #fff !important;
}

.teamPerformance .form-group .custom-select.smallselect {
  width: 64px;
}

@media (min-width: 1200px) {
  .teamPerformance h4.card-title {
    font-size: 18px;
  }
}
@media (min-width: 321px) and (max-width: 575.98px) {
  .teamPerformance .form-group .custom-select {
    width: 125px;
  }
  .teamPerformance h4.card-title {
    font-size: 18px;
  }
  .teamPerformance .card-body .form-group {
    margin-left: 24px !important;
  }
  .performance .card-body .form-group .custom-select {
    font-size: 14px;
    padding: 0;
    width: 85px;
    margin: 0 7px;
  }
  .teamPerformance .form-group .custom-select {
    font-size: 14px;
    padding: 0;
    width: 85px;
    margin: -11px 7px 0;
  }
}
.floating-labels .row {
  margin-left: -15px;
  margin-right: -15px;
}

.teamPerformance .form-group .custom-select {
  width: 144px;
}

.custom-select {
  display: inline-block;
  width: 98% !important;
}

.selectPerformanceBtn {
  font-size: 0.95rem !important;
  justify-content: center;
  justify-items: left;
  justify-self: center;
}

.floating-labels .form-group {
  display: flex;
}

.form-group {
  margin-bottom: 0.25rem !important;
}

.table-conatiner {
  padding: 20px;
  overflow: auto;
}

.form-row > div {
  margin-bottom: 1rem;
}

.hide-widget {
  position: absolute;
}`, "",{"version":3,"sources":["webpack://./src/app/home/team-performance/team-performance.component.scss"],"names":[],"mappings":"AAEA;EACE;IACE,WAAA;EAAF;EAGA;IACE,eAAA;IACA,UAAA;IACA,WAAA;IAEA,eAAA;EAFF;AACF;AAKA;EACE,aAAA;EACA,eAAA;AAHF;;AAMA;EACE,8BAAA;EACA,sBAAA;AAHF;;AAMA;EACE,WAAA;AAHF;;AAMA;EACE;IACE,eAAA;EAHF;AACF;AAMA;EACE;IACE,YAAA;EAJF;EAMA;IACE,eAAA;EAJF;EAOA;IACE,4BAAA;EALF;EAQA;IACE,eAAA;IACA,UAAA;IACA,WAAA;IACA,aAAA;EANF;EASA;IACE,eAAA;IACA,UAAA;IACA,WAAA;IACA,mBAAA;EAPF;AACF;AAUA;EACE,kBAAA;EACA,mBAAA;AARF;;AAWA;EACE,YAAA;AARF;;AAWA;EACE,qBAAA;EACA,qBAAA;AARF;;AAWA;EACE,6BAAA;EACA,uBAAA;EACA,mBAAA;EACA,oBAAA;AARF;;AAWA;EACE,aAAA;AARF;;AAWA;EACE,iCAAA;AARF;;AAWA;EACE,aAAA;EACA,cAAA;AARF;;AAWA;EACE,mBAAA;AARF;;AAWA;EACE,kBAAA;AARF","sourcesContent":["@import '../../../assets/theme/css/dashboard.css';\n\n@media (min-width: 1200px) {\n  .teamPerformance {\n    width: 100%;\n  }\n\n  .performance .card-body .form-group .custom-select {\n    font-size: 14px;\n    padding: 0;\n    width: 85px;\n    // margin: -11px 7px 0;\n    margin: 4px 7px;\n  }\n}\n\n.row {\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.table-responsive thead th {\n  background: #2a62ff !important;\n  color: #fff !important;\n}\n\n.teamPerformance .form-group .custom-select.smallselect {\n  width: 64px;\n}\n\n@media (min-width: 1200px) {\n  .teamPerformance h4.card-title {\n    font-size: 18px;\n  }\n}\n\n@media (min-width: 321px) and (max-width: 575.98px) {\n  .teamPerformance .form-group .custom-select {\n    width: 125px;\n  }\n  .teamPerformance h4.card-title {\n    font-size: 18px;\n  }\n\n  .teamPerformance .card-body .form-group {\n    margin-left: 24px !important;\n  }\n\n  .performance .card-body .form-group .custom-select {\n    font-size: 14px;\n    padding: 0;\n    width: 85px;\n    margin: 0 7px;\n  }\n\n  .teamPerformance .form-group .custom-select {\n    font-size: 14px;\n    padding: 0;\n    width: 85px;\n    margin: -11px 7px 0;\n  }\n}\n\n.floating-labels .row {\n  margin-left: -15px;\n  margin-right: -15px;\n}\n\n.teamPerformance .form-group .custom-select {\n  width: 144px;\n}\n\n.custom-select {\n  display: inline-block;\n  width: 98% !important;\n}\n\n.selectPerformanceBtn {\n  font-size: 0.95rem !important;\n  justify-content: center;\n  justify-items: left;\n  justify-self: center;\n}\n\n.floating-labels .form-group {\n  display: flex;\n}\n\n.form-group {\n  margin-bottom: 0.25rem !important;\n}\n\n.table-conatiner {\n  padding: 20px;\n  overflow: auto;\n}\n\n.form-row > div {\n  margin-bottom: 1rem; // adds vertical spacing between rows\n}\n\n.hide-widget {\n  position: absolute;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
